import React, {Component} from "react";
import './ReportToolbox.css'
import {connect} from "react-redux";
import axios from "../../../axios-cmk";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import FontAwesome from 'react-fontawesome';
import {massActionOnVisits, toggleReportsActionBar} from "../../../store/actions";
import {Button} from "reactstrap";

class ReportToolbox extends Component {
    render() {
        const className = this.props.action_bar_opened ? 'reportToolboxOpened' : 'reportToolbox'
        const disabled = (this.props.selected_visit_ids.length === 0)
        return (
            <div className={className}>
                <FontAwesome name='bars' className='action' onClick={this.props.toggleActionBar}/>
                <div className="reportActions">
                    <Button outline color="success"
                            size="sm"
                            className="firstButton actionButton"
                            onClick={(event) => this.props.massActionOnVisits('set_cancel_free')}
                            disabled={disabled}
                    >Bezpłatnie</Button>
                    <Button outline color="warning"
                            size="sm"
                            className="actionButton"
                            onClick={(event) => this.props.massActionOnVisits('set_cancel_paid')}
                            disabled={disabled}
                    >Odpłatnie</Button>
                    <Button outline color="danger"
                            size="sm"
                            className="actionButton"
                            onClick={(event) => this.props.massActionOnVisits('set_deleted')}
                            disabled={disabled}
                    >Usuń</Button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleActionBar: () => dispatch(toggleReportsActionBar()),
        massActionOnVisits: (actionName) => dispatch(massActionOnVisits(actionName)),
    }
}

const mapStateToProps = state => {
    return {
        action_bar_opened: state.reports.action_bar_opened,
        selected_visit_ids: state.reports.selected_visit_ids,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ReportToolbox, axios));


// WEBPACK FOOTER //
// ./src/components/Reports/ReportToolbox/ReportToolbox.js